<template>
  <div class="row project-details" v-if="canRead">
    <div v-show="!loading && updateAddressWarning"
          class="w-100 rounded bg-warning"
          style="padding: 15px 40px; margin-bottom: 15px;">
      <div v-if="!address.lat || !address.lng" class="d-flex justify-content-center align-items-center">
        <div class="text-center">
          This Project is missing Lat/Long.&nbsp;Check that address has <strong>City</strong> and <strong>Street Name/Number</strong>
          set and <strong>Save</strong> address to try to fetch coordinates.
        </div>
      </div>
      <div v-if="address.usingLatLngOfCity" class="text-center">
        This Project has its Lat/Long set to the city centre as the street address was not provided or couldn't be found when last saved.<br /><br />
        Check the Street Number and Street Name in Project Address below and <strong>Save</strong> to try to update Coordinates.
      </div>
    </div>
    <project-details :id="id"></project-details>
    <project-address :id="id"></project-address>
    <div class="space-below-collapse" style="width:100%">
      <div class="row">
        <div class="col-md-6">
          <h3 class="heading-departments">Departments</h3>
        </div>
        <div class="col-md-4 d-flex align-items-center ms-auto justify-content-end" style="margin-bottom: 20px; padding-right: 0">
          Expand All Departments
          <p-checkbox v-model="expandAllDepartments" @input="maybeCollapseDepartments" name="expandAllDepartments" style="margin-bottom: 35px; margin-left: 5px"></p-checkbox>
        </div>
        <div class="col-md-2">
          <div class="pull-right">
            <button v-if="canEdit" type="button" @click="editDepartments" class="btn btn-fill btn-info btn-wd  ">Edit Departments</button>
          </div>
        </div>
      </div>
      <div style="clear:both"></div>
      <project-departments :project-id="id" />
      <auditable-entity :data="project"></auditable-entity>
    </div>
  </div>
</template>
<script>
import ProjectDetails from './Details.vue'
import ProjectAddress from './Address.vue'
import ProjectDepartments from './Departments.vue'
import AuditableEntity from 'src/components/UIComponents/AuditableEntity'
import Permissions from 'src/utilities/permissions'
import {getParentEntityIdProjectDepartmentHash, getParentEntityIdProjectHash, notifyError} from 'src/utilities/utils'
import {OK} from 'http-status-codes'
import {mapGetters} from 'vuex'

export default {
  components: {
    AuditableEntity,
    ProjectDetails,
    ProjectAddress,
    ProjectDepartments
  },
  props: ['id'],
  computed: {
    ...mapGetters({
      project: 'projects/edit/details/all',
      address: 'projects/edit/address/all'
    }),
    expandAllDepartments: {
      get() {
        return this.$store.get('projects/edit/expandAllDepartments')
      },
      set(value) {
        this.$store.commit('projects/edit/setExpandAllDepartments', value)
      }
    },
    updateAddressWarning() {
      return !this.address.lat || !this.address.lng || this.address.usingLatLngOfCity
    },
    canRead() {
      return this.$can('read', Permissions.PROJECTS)
    },
    canEdit() {
      return this.$can('edit', Permissions.PROJECTS)
    }
  },
  data() {
    return {
      loading: true
    }
  },
  methods: {
    maybeCollapseDepartments(val) {
      if (!val) {
        this.$eventHub.$emit('collapseProjectDepartments')
      }
    },
    editDepartments() {
      this.$store.set('projects/edit/details/isActiveDepartment', true)
      this.$eventHub.$emit('show-modal-1', 'Edit Project Departments', {id: this.id}, '450px')
    },
    async fetchProject() {
      if (this.id) {
        this.loading = true
        const response = await this.$store.dispatch('fetchById', {
          endpoint: 'projects',
          id: this.id
        })

        this.loading = false

        if (OK !== response.status) {
          notifyError(this, 'Failed to Load Project')
          return
        }

        this.$store.commit('projects/edit/projectId', this.id)
        this.$store.commit('comments/addIdHash', getParentEntityIdProjectHash(this.id))
        if (response.data.departments) {
          this.$store.commit('projects/edit/departments', response.data.departments)
          for (const departmentId of response.data.departments) {
            this.$store.commit('comments/addIdHash', getParentEntityIdProjectDepartmentHash(this.id, departmentId))
          }
        }
        this.$store.commit('projects/edit/details/all', response.data)
        this.$store.commit('projects/edit/address/all', response.data.address)
      }
    },
    getCommentCounts() {
      this.$store.dispatch('comments/fetchCountsByParentEntityIdHash')
    },
    editTask(taskId) {
      this.$eventHub.$emit('show-modal-2', 'Edit Task', {id: taskId}, '80%')
    },
    reloadJobs() {
      this.$store.dispatch('jobs/fetchByProjectId', this.id)
    },
    handleRouteChange() {
      const regex = /taskId=([^&]+)/
      const match = window.location.href.match(regex)

      if (match) {
        this.editTask(match[1])
      }
    }
  },
  created() {
    // global data dependencies
    this.$store.cache.dispatch('tasks/names/fetchAll')
    this.$store.cache.dispatch('tasks/templates/fetchAll')
    this.$store.cache.dispatch('users/fetchAll')
    this.$store.cache.dispatch('priorities/fetchByEntityType', 'Job')
    this.$store.cache.dispatch('statuses/fetchByEntityType', 'Job')
    this.fetchProject()
    this.$store.dispatch('jobs/fetchByProjectId', this.id)
  },
  async mounted() {
    this.$eventHub.$on('jobDeleted', this.reloadJobs)
    window.addEventListener('popstate', this.handleRouteChange)
    await this.$eventHub.$on('projectJobsLoaded', this.getCommentCounts)
  },
  beforeDestroy() {
    this.$eventHub.$off('jobDeleted')
    this.$eventHub.$off('projectJobsLoaded')
    // TODO - some day refactor project edit to be simpler
    this.$store.commit('projects/edit/reset')
    this.$store.commit('projects/edit/details/reset')
    this.$store.commit('projects/edit/address/reset')
    this.$store.commit('jobs/resetProjectJobs')
    window.removeEventListener('popstate', this.handleRouteChange)
  }
}
</script>
<style>
  .space-below-collapse {
    margin-bottom: 15px;
  }
  .heading-departments {
    width:70%;
    float:left;
    padding-top: 7px
  }
</style>
